module.exports = __webpack_public_path__ + "img/3Dian5_2.b5438858.png";